import vRadio from "./v-radio.vue";
import vRadioGroup from "./v-radio-group.vue";

export default Vue => {
  Vue.component("v-radio", vRadio);
  Vue.component("v-radio-group", vRadioGroup);
};
